import React, { useState, useEffect } from 'react';
import { Skeleton } from '@mui/material';

import us from 'assets/images/dbDummy/us.png';
import eu from 'assets/images/dbDummy/eu.png';
import gbp from 'assets/images/dbDummy/ae.png';

const currencyOptions = [
	{ value: 'USD', label: 'USD', image: us },
	{ value: 'EUR', label: 'EUR', image: eu },
	{ value: 'AED', label: 'AED', image: gbp }
];

const CurrencyExchangeWidgetComponent = () => {
	const [rates, setRates] = useState({});
	const [amounts, setAmounts] = useState({ USD: '', EUR: '', AED: '' });
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		const fetchRates = async () => {
			setIsLoading(true);
			try {
				if (!api) {
					console.error("API object is not provided.");
					setIsLoading(false);
					return;
				}
				const rateData = await api.getExchangeRate();

				const ratesObject = rateData.reduce((acc, currency) => {
					acc[currency.name] = parseFloat(currency.rate);
					return acc;
				}, {});

				setRates(ratesObject);
				calculateInitialAmounts(ratesObject, 1, 'USD');
			} catch (error) {
				console.error("Failed to fetch exchange rates:", error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchRates();
	}, [api]);

	const calculateInitialAmounts = (currentRates, baseAmount, baseCurrency) => {
		const newAmounts = { [baseCurrency]: baseAmount.toString() };
		const sourceRate = currentRates[baseCurrency];
		if(!sourceRate) return;

		currencyOptions.forEach(option => {
			if (option.value !== baseCurrency) {
				const targetRate = currentRates[option.value];
				const convertedValue = (baseAmount / sourceRate) * targetRate;
				newAmounts[option.value] = convertedValue.toFixed(4);
			}
		});
		setAmounts(newAmounts);
	};

	const handleAmountChange = (sourceCurrency, value) => {
		const newAmounts = { ...amounts, [sourceCurrency]: value };
		const numericValue = parseFloat(value);

		if (isNaN(numericValue) || value === '') {
			Object.keys(newAmounts).forEach(key => {
				newAmounts[key] = (key === sourceCurrency) ? value : '';
			});
			setAmounts(newAmounts);
			return;
		}

		const sourceRate = rates[sourceCurrency];
		if (!sourceRate) return;

		currencyOptions.forEach(option => {
			if (option.value !== sourceCurrency) {
				const targetRate = rates[option.value];
				if(targetRate){
					const convertedValue = (numericValue / sourceRate) * targetRate;
					newAmounts[option.value] = convertedValue.toFixed(4);
				}
			}
		});

		setAmounts(newAmounts);
	};
	
	return (
		<div className="card" style={{ height: '230px', borderRadius: '3', boxShadow: '0 4px 12px rgb(0 0 0 / 0.05)', display: 'flex', alignItems: 'center', marginBottom: '2' }} >
			<div className="card-body" style={{ padding: '15px' }}>
				<div className="text-lg fw-500 mb-2">
					Currency Exchange
				</div>

				<div className="row g-2">
					{isLoading ? (
						currencyOptions.map(option => (
							<div className="col-12 col-md-12" key={option.value}>
								<Skeleton variant="text" width={80} height={20} className="mb-1" />
								<Skeleton variant="rounded" width={'100%'} height={38} />
							</div>
						))
					) : (
						currencyOptions.map(option => (
							<div className="col-12 col-md-12 py-3 flex align-items-center" key={option.value} style={{ gap: '12px' }}>
								<label
									htmlFor={`currency-${option.value}`}
									className="form-label d-flex align-items-center m-0"
									style={{fontSize: '0.875rem', width: '70px'}}
								>
									<img
										src={option.image}
										alt={option.label}
										style={{
											width: '20px',
											// height: '20px',
											// marginRight: '6px',
											height: '18px',
											marginRight: '6px',
											borderRadius: '4px'
										}}
									/>
									{option.label}
								</label>
								<input
									id={`currency-${option.value}`}
									type="number"
									className="form-control text-end"
									value={amounts[option.value] || ''}
									onChange={(e) => handleAmountChange(option.value, e.target.value)}
									placeholder="0.00"
									onFocus={(e) => e.target.select()}
								/>
							</div>
						))
					)}
				</div>

			</div>
		</div>
	);
};

export default CurrencyExchangeWidgetComponent;